import { useNavigate, useParams } from "react-router-dom";

import { Pane } from "src/components/Pane";
import { removeAllDrawnLayers } from "src/utils/map.utils";
import { PointSourceEmissionPointSourceCreatePage } from "./PointSourceEmissionPointSourceCreatePage";
import { PointSourceEmissionPointSourceEditPage } from "./PointSourceEmissionPointSourceEditPage";

interface Props {
  map: L.Map;
}

export function PointSourceEmissionPointSourcePage(props: Props) {
  const navigate = useNavigate();
  const { caseId = "", scenarioId = "", emissionId = "", pointSourceId = ""} = useParams<{
    caseId: string;
    scenarioId: string;
    emissionId: string;
    pointSourceId: string;
  }>();

  function handleClose(originAction?: "delete") {
    removeAllDrawnLayers(props.map);
    const url = `/cases/${caseId}/scenarios/${scenarioId}/emissions/point-source/${emissionId}`;
    navigate(url, {state: { originAction }});
  }

  return render();

  function render() {
    if (pointSourceId === "new") {
      return (
        <Pane>
          <PointSourceEmissionPointSourceCreatePage
            key={Object.values({caseId, scenarioId, emissionId, pointSourceId}).join()}
            onClose={handleClose}
            map={props.map}
          />
        </Pane>
      );
    }
    // else
    return (
      <Pane>
        <PointSourceEmissionPointSourceEditPage
          key={Object.values({caseId, scenarioId, emissionId, pointSourceId}).join()}
          onClose={handleClose}
          map={props.map}
        />
      </Pane>
    );
  }
}
